import { current } from "@reduxjs/toolkit";
import {
  decimal,
  formatToCurrency,
  formatToPercentage,
  getItemTypes
} from "src/utils/genericFunctions";
import stringToNumber from "src/utils/stringToNumber";

export const fetchProductSuccessDataFormat: any = (data: object[]) => {
  const vendorMap: { [key: string]: string } = {};

  const formattedData = data.map((item: any) => {
    if (item.vendorId && item.vendorName) {
      vendorMap[item.vendorId] = item.vendorName;
    }
    return {
      ...item,
      wos: String(decimal(item.wos)),
      retail: formatToCurrency(stringToNumber(item.retail)),
      value: formatToCurrency(stringToNumber(item.value)),
      salesUnit: decimal(item.salesUnit),
      salesRetail: formatToCurrency(stringToNumber(item.salesRetail)),
      avgRetail: formatToCurrency(stringToNumber(item.avgRetail)),
      margin: formatToPercentage(decimal(item.margin)),
      itemTypes: getItemTypes(item)
    };
  });
  return { formattedData, vendorMap };
};

export const handleFullfillForFetchProductData = (state: any, action: any) => {
  if (action.meta.requestId !== current(state).productsRequestId) {
    return;
  } else if (action?.payload?.data?.length > 0) {
    const { vendorMap, formattedData } = fetchProductSuccessDataFormat(
      action.payload.data
    );
    state.data = formattedData;
    state.vendorMap = vendorMap;
  } else {
    state.data = [];
  }
  state.status = "idle";
};

export const handleRejectForFetchProductData = (state: any) => {
  state.status = "error";
  state.data = [];
};

export const handlePendingForFetchProductData = (state: any, action: any) => {
  state.productsRequestId = action.meta.requestId;
  state.status = "pending";
};
